import { useCallback, useMemo } from "react";

const useRangeValidation = ({ validators, field }) => {
	const rangeValidator = useCallback(
		value => {
			const range = validators?.find(
				validator => validator.rangeValidator,
			);
			return range?.rangeValidator(field?.min, field?.max)(value);
		},
		[field?.max, field?.min, validators],
	);

	const otherValidators = useMemo(
		() => validators?.filter(validator => !validator.rangeValidator),
		[validators],
	);

	return { rangeValidator, otherValidators };
};

export default useRangeValidation;
